// extracted by mini-css-extract-plugin
module.exports = {"heading":"learning-testimonials-unit_heading__e6eA8","cta":"learning-testimonials-unit_cta__3mDBz"};